import { getBaseUserWithBillingData, sendGTM } from '../../helpers/gtm';
import { actions as PLAN_SUBSCRIPTIONS_ACTIONS } from '../../ducks/planSubscriptions';
import { isOrganization } from '../../helpers';
const planSubscriptionsMap = {
    [PLAN_SUBSCRIPTIONS_ACTIONS.BILLINGS_SUCCESS.toString()]: (state, action) => sendGTM(Object.assign(Object.assign({}, getBaseUserWithBillingData(state, action.payload)), { event: 'User_update', description: `Load ${isOrganization() ? 'Organization' : 'Natural'} User & Billing Data` })),
};
export default planSubscriptionsMap;
